<template>
  <div class="board-content">
    <div class="board-title">
      <span>靖边北华业开泰站台数据可视化看板</span>
    </div>
    <div class="board-container">
      <div class="left-board">
        <div class="carnum-info">
          <div class="left-board-title">发运车辆数统计</div>
          <div class="send-car-chart">
            <div id="weekCarNumCharts" class="car-num-chart"></div>
            <div id="monthCarNumCharts" class="car-num-chart"></div>
          </div>
        </div>
        <div class="carnum-info">
          <div class="left-board-title">卸货车辆数统计</div>
          <div class="send-car-chart">
            <div id="weekUnloadingCarCharts" class="car-num-chart"></div>
            <div id="monthUnloadingCarCharts" class="car-num-chart"></div>
          </div>
        </div>
      </div>
      <div class="right-board">
        <div class="right-board-top">
          <div v-for="item in carInfoList" :key="item.index" class="car-item">
            <span>{{ item.desc }}</span>
            <span>{{ item.num }}</span>
          </div>
        </div>
        <div class="right-board-center">
          <div class="finance-title">运费付款统计</div>
          <div class="finance-content">
            <div
              v-for="item in financeList"
              :key="item.id"
              class="finance-item"
            >
              <span>{{ item.desc + "(元)" }}</span>
              <span>{{ item.count }}</span>
            </div>
          </div>
        </div>
        <div class="right-board-bottom">
          <div class="bottom-title">实时过磅情况</div>
          <div class="table-container">
            <div class="table-header">
              <span>车牌号</span>
              <span>过磅状态</span>
              <span>毛重</span>
              <span>皮重</span>
              <span>净重</span>
              <span>时间</span>
            </div>
            <div class="table-content" @mouseenter="handleEnter" @mouseleave="handleMove">
              <div class="table" :style="{ top: listTop + 'px' }">
                <div
                  v-for="item in tableList"
                  :key="item.index"
                  class="table-item"
                >
                  <span>{{ item.carNo }}</span>
                  <span>{{ item.bangState }}</span>
                  <span>{{ item.grossWeight ? item.grossWeight.toFixed(2) : '--'}}</span>
                  <span>{{ item.tareWeight ? item.tareWeight.toFixed(2) : '--' }}</span>
                  <span>{{ item.netWeight ? item.netWeight.toFixed(2) : '--' }}</span>
                  <span>{{ item.time }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const carStatusEnum = {
  dispatchVehicleNum: "今日派车数",
  enterStationVehicleNum: "站内车辆数",
  outMineVehicleNum: "在途车辆数",
  outStationVehicleNum: "今日卸货数",
};
const financeEnum = {
  todayBillSum: "今日开票",
  todayPaySum: "今日付款",
  waitApprovalSum: "待审核",
  waitBillSum: "待开票",
  waitPaySum: "待付款",
};
export default {
  data() {
    return {
      weekCarNumCharts: null,
      monthCarNumCharts: null,
      carInfoList: [],
      financeList: [
        {
          key: 1,
          desc: "今日付款",
          count: "3320.22",
        },
        {
          key: 2,
          desc: "今日开票",
          count: "3320.22",
        },
        {
          key: 3,
          desc: "待审核",
          count: "3320.22",
        },
        {
          key: 4,
          desc: "待付款",
          count: "3320.22",
        },
        {
          key: 5,
          desc: "待开票",
          count: "3320.22",
        },
      ],
      tableList: [],
      timer: null,
      listTop: 0,
      countDownNo: 300 - 1,
      countDownTimer: null,
    };
  },
  mounted() {
    let loading = this.$loading({lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",})
    this.getData();
    this.getTodayCarInfo();
    this.getFinanceData();
    this.getScrollData();
    window.addEventListener("resize", () => {
      this.listenPageSizeChange();
    });
    setTimeout(() => {
      loading.close()
    }, 500);
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
      clearInterval(this.countDownTimer);
      this.timer = null;
      this.countDownTimer = null;
    });
  },
  methods: {
    async getData() {
      let res = await this.$api.showData.mGetCarInfo({});
      let data = [];
      this.weekCarNumCharts = this.renderBarCharts(
        {
          xAxisData: ["上周", "本周"],
          legendData: ["发运车辆数"],
          oldCount: res.data.outMineLastWeekCount,
          newCount: res.data.outMineCurrentWeekCount,
        },
        "weekCarNumCharts"
      );
      this.monthCarNumCharts = this.renderBarCharts(
        {
          xAxisData: ["上月", "本月"],
          legendData: ["发运车辆数"],
          oldCount: res.data.outMineLastMonthCount,
          newCount: res.data.outMineCurrentMonthCount,
        },
        "monthCarNumCharts"
      );
      this.weekUnloadingCarCharts = this.renderBarCharts(
        {
          xAxisData: ["上周", "本周"],
          legendData: ["卸货车辆数"],
          oldCount: res.data.enterStationLastWeekCount,
          newCount: res.data.enterStationCurrentWeekCount ,
        },
        "weekUnloadingCarCharts"
      );
      
      this.monthUnloadingCarCharts = this.renderBarCharts(
        {
          xAxisData: ["上月", "本月"],
          legendData: ["卸货车辆数"],
          oldCount: res.data.enterStationLastMonthCount,
          newCount: res.data.enterStationCurrentMonthCount,
        },
        "monthUnloadingCarCharts"
      );
      this.countDownTime = this.countDownTimeFn(this.countDownNo);
    },
    countDownTimeFn(time) {
      this.countDownTimer && clearTimeout(this.countDownTimer);
      if (time == 0) {
        // this.getStatisticsData();
        this.getData();
        this.getTodayCarInfo();
        this.getFinanceData();
        this.getScrollData();
        return "0:00";
      }
      let minute = Math.floor((time / 60) % 60);
      let seconds = Math.floor(time % 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      time--;
      this.countDownTimer = setTimeout(() => {
        this.countDownTime = this.countDownTimeFn(time);
      }, 1000);
      return `${minute}:${seconds}`;
    },
    async getTodayCarInfo() {
      let arr = [];
      let res = await this.$api.showData.mGetTodayCarInfo({});
      Object.keys(res.data).forEach((key) => {
        arr.push({
          desc: carStatusEnum[key],
          num: res.data[key],
        });
      });
      this.carInfoList = arr;
    },
    async getFinanceData() {
      let arr = [];
      let res = await this.$api.showData.mGetFinanceInfo({});
      Object.keys(res.data).forEach((key) => {
        arr.push({
          desc: financeEnum[key],
          count: res.data[key],
        });
      });
      this.financeList = arr;
    },
    async getScrollData() {
      let res = await this.$api.showData.mGetScrollList({});
      this.tableList = res.data && res.data.reverse();
      this.scrollMove();
    },
    renderBarCharts(data, type) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: data.legendData,
          textStyle: {
            color: "#fff",
          },
        },
        xAxis: [
          {
            type: "category",
            data: data.xAxisData,
            axisLabel: {
              show: true,
              textStyle: {
                color: "#657c97",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
             minInterval:1,
            name: "",
            nameTextStyle: {
              color: "#657c97",
            },
            axisLabel: {
              textStyle: {
                color: "#657c97",
              },
            },
          },
        ],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            name: data.legendData[0],
            type: "bar",

            /*设置柱状图颜色*/
            itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#0ff" },
                  { offset: 1, color: "#188df0" },
                ]),
                /*信息显示方式*/
                label: {
                  show: false,
                  position: "top",
                  formatter: "{b}\n{c}",
                },
              },
            },
            data: [data.oldCount, data.newCount]
          },
        ],
      };
      const echarts = this.$echarts.init(document.getElementById(type));
      echarts.setOption(option);
      return echarts;
    },
    listenPageSizeChange() {
      this.weekCarNumCharts && this.weekCarNumCharts.resize();
      this.monthCarNumCharts && this.monthCarNumCharts.resize();
      this.weekUnloadingCarCharts && this.weekUnloadingCarCharts.resize();
      this.monthUnloadingCarCharts && this.monthUnloadingCarCharts.resize();
    },
    clearEchartsInstance() {
      this.weekCarNumCharts && this.weekCarNumCharts.dispose();
      this.monthCarNumCharts && this.monthCarNumCharts.dispose();

      this.weekUnloadingCarCharts && this.weekUnloadingCarCharts.dispose();
      this.monthUnloadingCarCharts && this.monthUnloadingCarCharts.dispose();
    },
    scrollMove() {
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.listTop -= 1;
        if (this.listTop === -this.tableList.length * 15) {
          this.tableList.push(this.tableList.splice(0, 1)[0]);
          this.listTop = 0;
          clearInterval(this.timer);
          setTimeout(() => {
            this.scrollMove();
          }, 1000);
        }
      }, 100);
    },
    handleEnter(){
      clearInterval(this.timer);
      this.timer = null
    },
    handleMove(){
      this.scrollMove()
    }
  },
};
</script>

<style lang="scss" scoped>
.board-content {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/background.png");
  background-size: 100% 100%;

  .board-title {
    width: 100%;
    background: url("../../assets/titleBg.png");
    background-size: 100% 80%;
    height: 100px;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      text-align: center;
      line-height: 80px;
      color: #fff;
      font-weight: bold;
      font-size: 20px;
    }
  }
  .board-container {
    width: 100%;
    height: calc(100% - 100px);
    display: flex;
    .left-board {
      width: 40%;
      height: 100%;
      box-sizing: border-box;
      padding: 0 10px;
      .carnum-info {
        width: 100%;
        height: 48%;
        background: url("../../assets/component-cover.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .send-car-chart {
          width: 100%;
          height: calc(100% - 40px);
          display: flex;
          align-items: center;
          justify-content: space-around;
        }
        .left-board-title {
          width: 100%;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }
        .car-num-chart {
          width: 45%;
          height: 100%;
          box-sizing: border-box;
          padding: 10px;
        }
      }
      .unloadcar-info {
      }
    }
    .right-board {
      flex: 1;
      height: 100%;
      .right-board-top {
        width: 100%;
        height: 25%;
        display: flex;
        align-items: center;
        background: url("../../assets/component.png");
        background-repeat: no-repeat;
        background-size: 98% 90%;
        .car-item {
          width: 25%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: bold;
          color: #fff;
        }
        span {
          margin-top: 10px;
        }
      }
      .right-board-center {
        width: 100%;
        height: 25%;
        background: url("../../assets/component.png");
        background-repeat: no-repeat;
        background-size: 98% 90%;
        box-sizing: border-box;
        padding: 10px 0;
        .finance-title {
          width: 100%;
          text-align: center;
          font-weight: bold;
          font-size: 16px;
          color: #fff;
          margin-bottom: 10px;
        }
        .finance-content {
          width: 100%;
          height: calc(100% - 60px);
          display: flex;
          align-items: center;
          .finance-item {
            width: 25%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            font-weight: bold;
            color: #fff;
            span {
              margin-top: 10px;
            }
          }
        }
      }
      .right-board-bottom {
        width: 100%;
        height: 50%;
        background: url("../../assets/component-cover.png");
        background-repeat: no-repeat;
        background-size: 100% 93%;
        .bottom-title {
          width: 100%;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 18px;
        }
        .table-container {
          width: 100%;
          height: calc(100% - 40px);
          box-sizing: border-box;
          padding: 20px 0;
          .table-header {
            width: 100%;
            display: flex;
            align-items: center;
            span {
              min-width: 15%;
              text-align: center;
              color: #fff;
            }
          }
          .table-content {
            width: 100%;
            height: calc(100% - 40px);
            overflow-y: hidden;
            position: relative;
            .table {
              width: 100%;
              height: 100%;
              position: absolute;
            }
            .table-item {
              width: 100%;
              height: 30px;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding: 4px 0;
              span {
                min-width: 15%;
                text-align: center;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
</style>